window.getViewport = function getViewport() {
    // https://stackoverflow.com/a/8876069
    const width = Math.max(
        document.documentElement.clientWidth,
        window.innerWidth || 0
    )
    if (width <= 576) return 'xs'
    if (width <= 768) return 'sm'
    if (width <= 992) return 'md'
    if (width <= 1200) return 'lg'
    if (width <= 1400) return 'xl'
    return 'xxl'

    /*
    *   BOOTSTRAP 5 - $grid-breakpoints:
    *
    *   sm: 576px,
    *   md: 768px,
    *   lg: 992px,
    *   xl: 1200px,
    *   xxl: 1400px
    *
    * */
}

$(document).ready(function () {
    let viewport = getViewport()
    let debounce
    $(window).resize(() => {
        debounce = setTimeout(() => {
            const currentViewport = getViewport();
            if (currentViewport !== viewport) {
                viewport = currentViewport;
                //console.log(viewport);
                $(window).trigger('newViewport', viewport)
            }
        }, 500)
    })
    $(window).on('newViewport', (viewport, data) => {
        // do something with viewport
        //console.log(viewport);
        // console.log(data);
    })
    // run when page loads
    $(window).trigger('newViewport', viewport)
});


